var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-app-bar',{attrs:{"app":"","color":"accent"}},[_c('v-app-bar-title',[_c('span',[_vm._v("Edit multipoll")])])],1),_c('v-main',[_vm._v(" Edit ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }